import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { CommonConfig } from '../../configs/config.common';
import ListingCard from '../ListingCard/listing.card.vue';
import * as T_T from 'cryface';
import { uniq } from 'lodash';
import { Models } from '../../models/models';
import PropertyPicBanner from './PropertyPicBanner/property.pic.banner.vue';
import PropertySummary from './PropertySummary/property.summary.vue';
import PropertyMap from './PropertyMap/property.map.vue';
import PropertyInfoSummary from './PropertyInfoSummary/property.info.summary.vue';
import PropertyInfoDetail from './PropertyInfoDetail/property.info.detail.vue';
import PropertyInfoRooms from './PropertyInfoRooms/property.info.rooms.vue';
import PropertyDesc from './PropertyDesc/property.desc.vue';
import PropertySchools from './PropertySchools/property.schools.vue';
import PropertyCost from './PropertyCost/property.cost.vue';
import PropertyTrends from './PropertyTrends/property.trends.vue';
import PropertyNearby from './PropertyNearby/property.nearby.vue';
import PropertyHistory from './PropertyHistory/property.history.vue';
import PropertyDisclaimer from './PropertyDisclaimer/property.disclaimer.vue';
import { WechatDelegate } from '../../services/DataDelegate/WechatDelegate/wechat.delegate';
import { UserInfoDelegate } from '../../services/DataDelegate/UserInfoDelegate/user.info.delegate';
import { AxiosPromise } from '../../utils/axios.promise';
import { HimuraInject } from 'himura';
import * as dd from 'dingtalk-jsapi';

@Component({
   components: {
      ListingCard,
      PropertyPicBanner,
      PropertySummary,
      PropertyMap,
      PropertyInfoSummary,
      PropertyInfoDetail,
      PropertyInfoRooms,
      PropertyDesc,
      PropertySchools,
      PropertyCost,
      PropertyTrends,
      PropertyNearby,
      PropertyHistory,
      PropertyDisclaimer,
   }
})
export default class PropertyDetail extends Vue {
   public title: string = 'PropertyDetail';
   public metaTitle: string = '';

   public data: Models.IPropertyDetail | string = 'N/A';

   public userInfoService = new UserInfoDelegate();

   public configs = new CommonConfig();

   public wechat = new WechatDelegate();

   public isFetching = false;

   @Prop()
   public id: any;

   @Prop()
   public ltype: any;

   @Prop()
   public userid: any;

   @Watch('$store.state.auth.userInfo', { immediate: true, deep: true })
   public async onUserChanged(val: any, oldVal: any) {
      if (T_T.simpleDetect(val.value)) {
         this.$store.commit('propertyDetailStartFetching');
         await this.fetchDetail();
         await this.congiuringWX(val);
         await this.configSocial(val);
         await T_T.delay(500);
         this.$store.commit('propertyDetailEndFetching');
         this.isFetching = false;
         await this.configDingTalk(val);
      }
   }

   public async configDingTalk(val: any) {
      if (window.navigator.userAgent.toLowerCase().indexOf('dingtalk') === -1) {
         return;
      }
      const _data: any = this.data;
      const name = val.value.agentName;
      const picture = T_T.simpleDetect(_data.pictures) ? _data.pictures[0] : this.configs.housePicPlaceHolder;
      const content = this.getShareDesc(_data);
      dd.biz.navigation.setRight({
         show: true,
         control: true,
         text: '',
         onSuccess : function() {
            dd.biz.util.share({
               type: 0,
               url: location.href.split('#')[0],
               title: T_T.simpleDetect(name)
                  ? `${name} 推荐 \$${_data.price} - ${_data.fullAddress}`
                  : `向您推荐 \$${_data.price} - ${_data.fullAddress}`,
               content: content,
               image: picture
            });
         }
     });
   }
   @Watch('$store.state.mapEpic.mapPageDetailObject', { immediate: true, deep: true })
   public onIdInput(val: any, oldVal: any) {
      if (val) {
         this.id = val.id;
         this.configSocial(val);
         this.isFetching = false;
         // console.log(this.id, 'this.id');
      }
   }

   public async created() {
      this.isFetching = true;
   }

   public getShareDesc(data: Models.IPropertyDetail) {
      let desc = '您可能对它感兴趣: ';
      desc += `${data.propertyType}, `;
      const bed = T_T.simpleDetect(data.bedrooms) ? data.bedrooms : 'N/A';
      desc += `${bed}卧, `;
      const bath = T_T.simpleDetect(data.washrooms) ? data.washrooms : 'N/A';
      desc += `${bath}卫`;
      // desc += data.brokerage;
      return desc;
   }

   public async fetchDetail() {
      const ltype = T_T.simpleDetect(this.ltype) ? this.ltype : 1;
      const userid = T_T.simpleDetect(this.userid) ? this.userid : 1;
      const apiHost = this.configs.cmisapiHost;
      const dataFetched = await AxiosPromise.get(`${apiHost}/mh/queryHouByid?houid=${this.id}&ltype=${ltype}&userid=${userid}`);
      if (dataFetched.code === 200) {
         const data = dataFetched.data;
         console.log(data);
         (data as Models.IPropertyDetail).RifoTags = [];
         this.goodSchoolCal(data);
         this.dataMapper(data);
         data.pictures = T_T.simpleDetect(data.pictures) ? data.pictures : [this.configs.housePicPlaceHolder];
         this.data = data;
      } else { }
   }

   public goodSchoolCal(data: Models.IPropertyDetail) {
      data.HouSchoolList.map((school: any) => {
         const total = school.rank.split('/')[1];
         const rank = school.rank.split('/')[0];
         if (Number(rank) / Number(total) < 0.1) {
            data.RifoTags!.push('GoodSchool');
         }
      });
   }

   public dataMapper(data: any) {
      data.buyStats = {
         firstPay: data.firstPay,
         theFirstTax: data.theFirstTax,
         totalPay: data.totalPay,
         notTheFirstTax: data.notTheFirstTax,
         monthPay: data.monthPay
      };
      data.locating = {
         lng: data.longitude,
         lat: data.latitude
      };
      data.summary = {
         id: data.mlsNumber,
         zoning: data.zoning,
         ownership: data.ownership,
         propertyType: data.propertyType,
         dom: data.dom,
         type: data.listingType,
         city: data.city,
         community: data.community,
         garages: data.garages,
         parkings: data.parkingSpaces,
         lotArea: data.newLotArea,
         usageArea: data.newUsageArea,
         buildingArea: data.newBuildingArea,
         apxAge: data.approxAge,
         builtYear: data.builtYear,
         maintFee: data.managementFee,
         frontOn: data.fronting,
         storeys: data.storey,
         occupancyDate: data.occupyDate,
         brokerage: data.brokerage,
      };
      data.detailInfo = {
         price: data.price,
         priceUnit: data.priceUnit,
         fullAddress: data.fullAddress,
         bedrooms: data.bedrooms,
         bedroomsPlus: data.bedroomsPlus,
         washrooms: data.washrooms,
         otherFee: data.otherFee,
         openHouse: data.openHouse,

         utilityIncludes: data.utilityIncludes,
         utilityFeatures: data.utilityFeatures,
         tax: (data.listingType === 'Sale' && data.zoning !== 'Commercial') ? data.tax : 'N/A',
         condoFeatures: data.condoFeatures,
         otherFeatures: data.otherFeatures,
         poolInfo: data.poolInfo,
         basements: data.basements,
         crossStreets: data.crossStreets
      };
      data.propertySummary = {
         fullAddress: data.fullAddress,
         price: data.price,
         soldPrice: T_T.simpleDetect(data.soldPrice) ? data.soldPrice : null,
         soldDate: data.soldDate,
         tax: (data.listingType === 'Sale' && data.zoning !== 'Commercial') ? data.tax : 'N/A',
         type: data.listingType,
         community: data.community,
         bedrooms: data.bedrooms,
         bedroomsPlus: data.bedroomsPlus,
         washrooms: data.washrooms,
         garages: data.garages,
         crossStreets: data.crossStreets,
         maintFee: data.managementFee,
         monthPay: (data.listingType === 'Sale' && data.zoning !== 'Commercial') ? data.monthPay : 'N/A',
         tags: uniq(data.RifoTags),
      };
      // console.log(data);
   }

   public async configSocial(val: any) {
      const link = this.$store.state.app.isWWW ? `https://${this.configs.worldWide[0]}/listing/${this.id}` : location.href.split('#')[0];
      const _data: any = this.data;
      const picture = T_T.simpleDetect(_data.pictures) ? _data.pictures[0] : this.configs.housePicPlaceHolder;
      const name = T_T.simpleDetect(val.value) ? val.value.agentName : null;
      const config = {
         url: link, // 网址，默认使用 window.location.href
         source: '', // 来源（QQ空间会用到）, 默认读取head标签：<meta name="site" content="http://overtrue" />
         title: T_T.simpleDetect(name) ? `${name} 推荐 \$${_data.price} - ${_data.fullAddress}` : `向您推荐 \$${_data.price} - ${_data.fullAddress}`,
         description: this.getShareDesc(_data), // 描述, 默认读取head标签：<meta name="description" content="PHP弱类型的实现原理分析" />
         image: picture,
         wechatQrcodeTitle: '微信扫一扫：分享', // 微信二维码提示文字
         wechatQrcodeHelper: '<p>微信里点“发现”，扫一下</p><p>二维码便可分享至朋友圈。</p>'
      };
      this.$store.commit('setSocialShare', config);
   }

   public async congiuringWX(val: any) {
      if (this.wechat.isWeChat()) {
         const entry = HimuraInject.Injector.getInstance().getResourceByKey('entryUrl')!.value;
         const link = this.wechat.isWechatIos() ? entry.split('#')[0] : location.href.split('#')[0];
         const _data: any = this.data;
         const name = val.value.agentName;
         const picture = T_T.simpleDetect(_data.pictures) ? _data.pictures[0] : this.configs.housePicPlaceHolder;
         const shareConfig: Models.IWechatShareConfig = {
            title: T_T.simpleDetect(name) ? `${name} 推荐 \$${_data.price} - ${_data.fullAddress}` : `向您推荐 \$${_data.price} - ${_data.fullAddress}`,
            desc: this.getShareDesc(_data),
            link: location.href.split('#')[0],
            imgUrl: picture,
            success: () => {
            }
         };
         const wx = require('weixin-js-sdk');
         const options = await this.wechat.getConfig(link);
         wx.config(options);
         try {
            await this.wechat.ReadyPromise(wx);
            this.wechat.share(wx, shareConfig);
         } catch (e) {
            alert(e.errMsg);
            alert(`${link} Link --------------`);
            alert(`${shareConfig.link} Shared Link --------------`);
            alert(location.href);
         }
      }
   }
}
